import keyboardFocus from 'keyboard-focus';
import AOS from 'aos';
import { initScroll } from '../plugins/smooth-scroll';
import initRevealed from '../plugins/revealed';
export default () => {
  AOS.init({
    disable: ['mobile', 'phone', 'tablet'],
    duration: 300,
    easing: 'ease-out',
    startEvent: 'load'
  });
  keyboardFocus(document);
  initScroll();
  initRevealed();
};